<template>
  <div>
    <div v-if="show">
      <el-cascader
        style="width: 100%;"
        v-model="val"
        :props="props"
        :placeholder="placeholder"
        @change="change"
      ></el-cascader>
    </div>
  </div>
</template>
<script>
import Api from "@/plugins/axios.js";
export default {
  props: {
    value: {
      type: [Array, String]
    },
    placeholder: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      show: true,
      val: [], // v-model 的绑定
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          let li = [];
          if (node.level > 0) {
            Api.buidCates(node.value).then(re => {
              console.log(node);
              li = re.map(e => {
                return {
                  value: e.id.toString(),
                  label: e.name,
                  leaf: e.child_count === 0
                };
              });
              resolve(li);
            });
          } else {
            Api.buidCates(0).then(re => {
              li = re.map(e => {
                return {
                  child_count: e.child_count,
                  value: e.id.toString(),
                  label: e.name,
                  leaf: e.child_count === 0
                };
              });
              resolve(li);
            });
          }
        }
      }
    };
  },
  mounted() {
    this.val = this.value;
  },
  watch: {
    value(val) {
      this.show = false;
      this.val = val;
      const that = this;
      setTimeout(function() {
        that.show = true;
      }, 1);
      console.log("下拉分类显示变换了", val);
    }
  },
  methods: {
    // 修改事件
    change(e) {
      this.$emit("input", e);
    }
  }
};
</script>
